import React from 'react';
import { Row, Col, Card, Typography, Rate, Avatar } from 'antd';
import { UserOutlined, StarFilled } from '@ant-design/icons';
import { shopConfig, getThemeColors } from '../../config/shop.config';

const { Title, Text, Paragraph } = Typography;

const TestimonialsSection: React.FC = () => {
  const themeColors = getThemeColors();
  const testimonials = shopConfig.testimonials;

  if (!testimonials.enabled || testimonials.reviews.length === 0) {
    return null; // Don't show section if disabled or no reviews
  }

  return (
    <div style={{ padding: '80px 20px', backgroundColor: '#f9fafb' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{ marginBottom: '16px' }}>
            <StarFilled style={{ fontSize: '48px', color: '#fbbf24' }} />
          </div>
          <Title level={2} style={{ color: themeColors.primary }}>
            What Our Customers Say
          </Title>
          <Paragraph style={{ fontSize: '18px', color: '#6b7280', maxWidth: '700px', margin: '0 auto' }}>
            Real feedback from satisfied customers who trust us with their vehicles
          </Paragraph>
        </div>

        {/* Testimonials Grid */}
        <Row gutter={[32, 32]}>
          {testimonials.reviews.map((review) => (
            <Col xs={24} md={12} lg={8} key={review.id}>
              <Card
                style={{
                  height: '100%',
                  borderRadius: '16px',
                  border: '2px solid #e5e7eb',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.3s ease',
                }}
                hoverable
                styles={{ body: { padding: '24px' } }}
              >
                {/* Rating */}
                <div style={{ marginBottom: '16px' }}>
                  <Rate disabled defaultValue={review.rating} style={{ color: '#fbbf24', fontSize: '18px' }} />
                </div>

                {/* Review Text */}
                <Paragraph
                  style={{
                    fontSize: '15px',
                    color: '#4b5563',
                    marginBottom: '20px',
                    minHeight: '80px',
                    fontStyle: 'italic',
                  }}
                >
                  "{review.text}"
                </Paragraph>

                {/* Customer Info */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
                  <Avatar
                    size={48}
                    src={review.avatar}
                    icon={!review.avatar && <UserOutlined />}
                    style={{
                      backgroundColor: review.avatar ? 'transparent' : themeColors.primary,
                    }}
                  />
                  <div>
                    <Text strong style={{ display: 'block', fontSize: '16px', color: '#111827' }}>
                      {review.name}
                    </Text>
                    {review.date && (
                      <Text type="secondary" style={{ fontSize: '13px' }}>
                        {review.date}
                      </Text>
                    )}
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Trust Message */}
        <div
          style={{
            marginTop: '48px',
            textAlign: 'center',
            padding: '32px',
            background: `linear-gradient(135deg, ${themeColors.primary}10 0%, ${themeColors.accent}10 100%)`,
            borderRadius: '16px',
            border: `2px solid ${themeColors.primary}20`,
          }}
        >
          <Title level={4} style={{ color: themeColors.primary, marginBottom: '8px' }}>
            Join Our Satisfied Customers
          </Title>
          <Text style={{ fontSize: '16px', color: '#4b5563' }}>
            Experience the same quality service and honest pricing that our customers love
          </Text>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
